/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UnpairDeviceModel as DigiworkMaitreDPosDtoEmployeeUnpairDeviceModel } from '../../models/Digiwork/MaitreD/Pos/DTO/Employee/unpair-device-model';

export interface UnPairDevice$Params {
      body?: DigiworkMaitreDPosDtoEmployeeUnpairDeviceModel
}

export function unPairDevice(http: HttpClient, rootUrl: string, params?: UnPairDevice$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, unPairDevice.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

unPairDevice.PATH = '/api/pos/OrderBill/unpairdevice';
